function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0H1440V1276H0z",
  transform: "translate(-688 -158)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M700 169l.079.004.065.006.059.01.11.03.11.044.061.03.075.046.06.045.088.078 2 2 .083.094c.28.36.28.866 0 1.226l-.083.094-.094.083c-.36.28-.866.28-1.226 0l-.094-.083-.294-.292L701 179l-.007.117c-.053.459-.417.823-.876.876L700 180l-.117-.007c-.459-.053-.823-.417-.876-.876L699 179l-.001-6.584-.292.291-.094.083c-.392.305-.96.278-1.32-.083-.36-.36-.388-.928-.083-1.32l.083-.094 2-2 .112-.097.074-.05.098-.052.081-.034.113-.034.112-.02L700 169zm0-9c2.856 0 5.245 1.995 5.851 4.667l.048.23.028.175.175.029c2.636.49 4.667 2.702 4.88 5.425l.014.25.004.224c0 3.142-2.42 5.735-5.538 5.982l-.224.013L705 177h-1c-.552 0-1-.448-1-1s.448-1 1-1h.979l.195-.004c2.135-.09 3.826-1.852 3.826-3.996 0-2.21-1.79-4-4-4-.552 0-1-.448-1-1 0-2.21-1.79-4-4-4-2.077 0-3.795 1.587-3.982 3.608l-.014.196-.004.217c-.01.498-.384.905-.866.97l-.113.009-.195.004c-2.135.09-3.826 1.852-3.826 3.996 0 2.142 1.684 3.891 3.8 3.995l.2.005h1c.552 0 1 .448 1 1s-.448 1-1 1h-1c-3.238 0-5.878-2.566-5.996-5.775L689 171c0-2.837 1.973-5.225 4.65-5.845l.231-.048.19-.034.036-.208c.503-2.627 2.716-4.636 5.422-4.847l.248-.014L700 160z",
  transform: "translate(-688 -158)"
}));

var SvgIc24Cloud = function SvgIc24Cloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIc24Cloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-24-cloud.895641da.svg";
export { ForwardRef as ReactComponent };